module.exports = __webpack_public_path__ + "img/ic-order.892bccac.svg";